<template>
  <div class="bind-location-info-bd ubv ub-f1">
    <div class="ub" style="margin-bottom: 24px">
      <div class="ub-f1" style="margin-right: 12px">
        <search-input width="100%" :placeholder="$t('bl_info_gsmc')" v-model="formSearch.orgName" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
       <div class="ub-f2">
        <search-input width="100%" :placeholder="$t('bl_info_xmmc')" v-model="formSearch.locationName" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
    </div>
    <div class="table-bd ub-f1">
      <custom-table height="100%" index stripe tableCode="portal_user_location" :data="tableList"></custom-table>
    </div>
    <div class="table-page">
      <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

// bl_info_gsmc: 公司名称// bl_info_xmmc: 项目名称

export default {
  name: 'bind_location_info',
  props: {
    userId: {
      type: [String, Number, Boolean],
      default: '',
    },
  },
  data() {
    return {
      formSearch: {
        orgId: '',
        userId: '',
        search: '',
        locationName: '',
        orgName: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
    };
  },
  watch: {
    userId: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.tableList = [];
      this.totalRows = 0;
      this.getLocationList();
    },
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_bind_location_info');
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getLocationList();
    this.getFuncView();
  },
  methods: {
    // 获取关联项目
    getLocationList: function () {
      if (!this.userId) {
        return;
      }
      this.formSearch.userId = this.userId;
      this.$getJSON(apis.deviceUserLocation, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLocationList();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
</style>
